import { PersonaAutoriza } from './areas.service';
import { DataLogin } from './autenticacion.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const smartHomeUrl = 'https://as-ws-smarthome.azurewebsites.net/';
@Injectable({
  providedIn: 'root'
})
export class LugaresService {

  constructor(private _http: HttpClient) { }

  getLugares(page: number, palabrasClave: string): Observable<ResultadoServicio<LugaresUnidad>> {
    const loginData: DataLogin = JSON.parse(localStorage.getItem('data_login'));

    const requestUrl = `${smartHomeUrl}api/unidades/unidad/${loginData.company_id}?key=${palabrasClave}&page=${page + 1}&cant=8`;

    const headers = new HttpHeaders({
      'dataLugares': 'true'
    });

    return this._http.get<ResultadoServicio<LugaresUnidad>>(requestUrl, { headers });
  }

  getLugar(idLugar: string): Observable<ResultadoServicio<DataLugar>> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idLugar}`;

    const headers = new HttpHeaders({
      'dataLugar': 'true'
    });

    return this._http.get<ResultadoServicio<DataLugar>>(requestUrl, { headers });
  }

  asignarTitularInmueble(idInmueble: string, indicativo: string, celular: string): Observable<ResultadoCambioTitular> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idInmueble}`;

    const headers = new HttpHeaders({
      'dataTitular': 'true'
    });

    let body = {
      indicative: indicativo,
      phone: celular
    };

    return <Observable<ResultadoCambioTitular>> this._http.patch(requestUrl, body, { headers });
  }

  eliminarTitularInmueble(idInmueble: string): Observable<ResultadoCambioTitular> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idInmueble}`;

    const headers = new HttpHeaders({
      'dataTitular': 'false'
    });

    return <Observable<ResultadoCambioTitular>> this._http.patch(requestUrl, {}, { headers });
  }

  traerGrupoFamiliar(idInmueble: string): Observable<GrupoFamiliarResponse> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idInmueble}`;

    const headers = new HttpHeaders({
      'dataGrupoFamiliar': 'true'
    });

    return <Observable<GrupoFamiliarResponse>> this._http.get(requestUrl, { headers });
  }

  cambiarInvitadosPermitidosMiembroFamilia(idInmueble: string, miembro: MiembroFamilia): Observable<ResultadoServicio<ActualizarGrupoFamiliarResponse>> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idInmueble}`;

    const headers = new HttpHeaders({
      'dataGrupoFamiliar': 'true'
    });

    const body = {
      user_id: miembro.id,
      guests_allowed: String(miembro.guests_allowed) === "1" ? "0" : "1"
    };

    return <Observable<ResultadoServicio<ActualizarGrupoFamiliarResponse>>> this._http.patch(requestUrl, body, { headers });
  }

  actualizarInformacionInmueble(idInmueble: string, area: string = null, apartamento: string = null, costoAdministracion: number = null, estado: number): Observable<EditarInmuebleResponse> {
    const requestUrl = `${smartHomeUrl}api/lugares/lugar/${idInmueble}`;

    const headers = new HttpHeaders({
      'dataLugar': 'false'
    });

    const body = {
      status: estado
    };

    if(area) body["area_name"] = area;
    if(apartamento) body["local_number"] = apartamento;
    if(costoAdministracion) body["admon_cost"] = costoAdministracion;

    return <Observable<EditarInmuebleResponse>> this._http.patch(requestUrl, body, { headers });
  }
}

export interface ResultadoServicio<T> {
  data: T;
}

export interface ActualizarGrupoFamiliarResponse {
  lugar: {
    user_id: number,
    guests_allowed: string
  },
  message: string
}

export interface ResultadoCambioTitular {
  data: {
    message: string;
  };
}

export interface DataLugar {
  data_lugar: Lugar;
}

export interface LugaresUnidad {
  lugares: Lugar[];
}

export interface Lugar {
  area_id: number;
  area_name: string;
  class_id: number;
  company_id: number;
  id: number;
  local_number: number;
  site_id: number;
  site_name: string;
  type: string;
  admon_cost: number;
  owner?: boolean;
  user_name?: string;
  user_type_document?: string;
  user_number_document?: string;
  indicativo? : string;
  celular?: string;
  status: number;
  description?: string;
  miembros?: PersonaAutoriza[];
}

export interface GrupoFamiliarResponse {
  data: {
    grupofamiliar: MiembroFamilia[]
  }
}

export interface MiembroFamilia {
    id: number,
    name: string,
    type_document: string,
    number_document: string,
    indicative: string,
    phone: string,
    status: number,
    guests_allowed: number,
    imagen?: string
}

export interface EditarInmuebleResponse {
  data: {
    lugar: {
      area_name?: string,
      admon_cost?: number,
      local_number?: number
    }
  }
}